import React            from 'react';
import ReactDom         from 'react-dom';
import Moment           from 'moment';

import Const            from 'fw_const';
import Utils            from 'utils';

import ContentsHeader   from './header/contents-header';
import ProgressContents from './progress/progress-contents';
import SheetContents    from './sheet/_sheet';
// -------------------------------------------------------

class Workflow extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      viwe_type    : 'work',
      work_tab     : 'workflow',
      //work_tab     : 'sheet',
      search_word  : '',
      ng_view_mode : Utils.getLocalData({ id: 'project/workflow/ng_view_mode', default: 'false' }),
    };
  }
  // -------------------------------------------------------
  
  refreshWorkflow() {
    let data = this.props.data;
    
    Utils.request.bind(this)('/api/project/workflow/get_workflow', { project_id: data.project.id },
      function(res){
        data.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  refreshProject() {
    let data = this.props.data;
    
    Utils.request.bind(this)('/api/project/workflow/get_project', { project_id: data.project.id },
      function(res){
        let project = res.body.project;
        data.event.updateData('workflow', project.workflow);
        data.event.updateData('report', project.report);
        data.event.updateData('project', project.project);
        data.event.updateData('check_draft', project.check_draft);
        data.event.updateData('userData', project.userData);
        data.event.updateData('dm_already_read', project.dm_already_read);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  setWorkTab(work_tab) {
    this.setState({ work_tab: work_tab });
  }
  // -------------------------------------------------------
  
  setSearchWord(search_word) {
    this.setState({ search_word: search_word });
  }
  // -------------------------------------------------------
  
  setNg(ng_mode) {
    this.setState({ ng_view_mode: ng_mode });
    Utils.saveLocalData({ id: 'project/workflow/ng_view_mode', data: ng_mode });
  }
  // -------------------------------------------------------
  
  showWorkGroups(workflow) {
    
    // インフルエンサー検索に適用
    let items = {};
    for( let p in workflow.items_base ){
      if( items[p] == undefined ) items[p] = [];
      
      workflow.items_base[p].map((d) => {
        if( this.state.search_word == '' ){
          items[p].push(d);
          return;
        }
        
        try {
          if( d.influencer.full_name.indexOf(this.state.search_word) >= 0 || d.influencer.insta_id.indexOf(this.state.search_word) >= 0 || d.influencer.insta_user_id == this.state.search_word ){
            items[p].push(d);
          }
        } catch(e) {}
      });
    }
    workflow.items = items;
    
    return workflow;
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    data.workflow = this.showWorkGroups.bind(this)(Object.assign({}, data.workflow));
    data.event.refreshWorkflow = this.refreshWorkflow.bind(this);
    data.event.refreshProject = this.refreshProject.bind(this);
    data.ng_view_mode = this.state.ng_view_mode;
    
    let work_tab = this.state.work_tab;
    
    return (
      <div className="project-workflow">
        <ContentsHeader base={data} work_tab={work_tab} set_ev={this.setSearchWord.bind(this)} tab_ev={this.setWorkTab.bind(this)} ng_ev={this.setNg.bind(this)} />
        
        { (work_tab == 'workflow') && <ProgressContents base={data} /> }
        { (work_tab == 'sheet') && <SheetContents data={data} /> }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Workflow;